"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BAIL_TIMEOUT_ERROR_MESSAGE = void 0;
exports.default = fetchWithRetry;
const async_retry_1 = __importDefault(require("async-retry"));
const lang_1 = require("../lang");
const filter_1 = __importDefault(require("../object/filter"));
const promises_1 = require("../promises");
const promises_2 = require("../promises");
const defaultRetryOptions = { retries: 2 };
exports.BAIL_TIMEOUT_ERROR_MESSAGE = 'bailTimeout reached';
const isNotNil = (val) => !(0, lang_1.isNil)(val);
function transformFetchOptions(fetchOptions, post) {
    return {
        ...fetchOptions,
        method: 'POST',
        headers: {
            ...fetchOptions.headers,
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(post),
    };
}
function getRetryAfterMs(headers) {
    const retryAfter = headers.get('Retry-After');
    if (!retryAfter) {
        return;
    }
    if (Number.isNaN(Number(retryAfter))) {
        return Math.max(new Date(retryAfter).getTime() - Date.now(), 0) || 0;
    }
    return Number(retryAfter) * 1000;
}
function fetchWithRetry(resource, options) {
    const { retries = defaultRetryOptions.retries, factor, minTimeout, maxTimeout, randomize, onRetry, parseAs = 'json', post, bailTimeout, ...fetchOptions } = options || {};
    const retryOptions = {
        retries,
        factor,
        minTimeout,
        maxTimeout,
        randomize,
        onRetry,
    };
    async function retrier(bail) {
        let res;
        const fetchPromise = fetch(resource, post ? transformFetchOptions(fetchOptions, post) : fetchOptions);
        if (!bailTimeout) {
            res = await fetchPromise;
        }
        else {
            try {
                res = (await (0, promises_1.rejectAfter)(fetchPromise, bailTimeout, exports.BAIL_TIMEOUT_ERROR_MESSAGE));
            }
            catch (e) {
                if (e === exports.BAIL_TIMEOUT_ERROR_MESSAGE) {
                    return bail(new Error(exports.BAIL_TIMEOUT_ERROR_MESSAGE));
                }
                throw e;
            }
        }
        if (res.ok) {
            return parseAs ? res[parseAs]?.() : res;
        }
        if (res.status === 429) {
            const retryAfterMs = getRetryAfterMs(res.headers);
            if (retryAfterMs) {
                await (0, promises_2.wait)(Math.max(retryAfterMs - (minTimeout ?? 1000), 0));
            }
        }
        throw res;
    }
    return (0, async_retry_1.default)(retrier, (0, filter_1.default)(retryOptions, isNotNil));
}
